export function validatorCard(v, back) {
  let birthday = ''
  let sex = ''
  let C15ToC18 = (c15) => {
    let cID = c15.substring(0, 6) + '19' + c15.substring(6, 15)
    let jy = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
    let iq = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    let it = 0
    for (let i = 0; i < cID.length; i++) {
      it += parseInt(cID.substring(i, i + 1)) * iq[i]
    }
    it %= 11
    cID += jy[it]
    return cID
  }
  let Is18IDCard = (IDNum) => {
    let aCity = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外'
    }
    let iSum = 0
    let sID = IDNum
    if (!/^\d{17}(\d|x)$/i.test(sID)) {
      return false
    }
    sID = sID.replace(/x$/i, 'a')
    if (aCity[parseInt(sID.substr(0, 2))] == null) {
      return false
    }
    let sBirthday = sID.substr(6, 4) + '-' + sID.substr(10, 2) + '-' + sID.substr(12, 2)
    let d = new Date(sBirthday.replace(/-/g, '/'))
    let dm = d.getMonth() + 1
    let dd = d.getDate()
    if (sBirthday !== (d.getFullYear() + '-' + (dm > 9 ? dm : '0' + dm) + '-' + (dd > 9 ? dd : '0' + dd))) return false
    birthday = sBirthday
    sex = sID.substr(16, 1)
    for (let i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sID.charAt(17 - i), 11)
    if (iSum % 11 !== 1) return false
    return true
  }
  if (!back) {
    return v.length === 15 ? Is18IDCard(C15ToC18(v)) : Is18IDCard(v)
  } else {
    if (v.length === 15 ? Is18IDCard(C15ToC18(v)) : Is18IDCard(v)) {
      back(birthday, sex)
    }
  }
}

export function saveLocal(id, key, val) {
  let store = window.localStorage._store_
  if (!store) {
    store = {}
    store[id] = {}
  } else {
    store = JSON.parse(store)
    if (!store[id]) {
      store[id] = {}
    }
  }
  store[id][key] = val
  window.localStorage._store_ = JSON.stringify(store)
}

export function readLocal(id, key, defaults) {
  let store = window.localStorage._store_
  if (!store) {
    return defaults
  }
  store = JSON.parse(store)[id]
  if (!store) {
    return defaults
  }
  let ret = store[key]
  return ret || defaults
}

export function removeLocal(id, key) {
  let store = window.localStorage._store_
  if (store) {
    store = JSON.parse(store)
    if (store[id]) {
      if (key) {
        if (store[id][key]) {
          delete store[id][key]
        }
      } else {
        delete store[id]
      }
      window.localStorage._store_ = JSON.stringify(store)
    }
  }
}

export function formatNumber(val, num) { // num 为0时表示要返回整数
  val = typeof val === 'number' ? val.toString() : val
  if (typeof val === 'string') {
    if (num === 0) {
      return val.replace(/[^\d]/g, '')
    } else {
      num = num || 3
      if (val === '') return ''
      val = val.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^\./g, '').replace(/\./, '$#$').replace(/\./g, '').replace('$#$', '.')
      let reg = new RegExp('(\\d+)(\\.?\\d{0,' + num + '}).*$')
      val = val.replace(reg, '$1$2')
      let idx = val.indexOf('.')
      if (idx !== -1 && idx < val.length) {
        let v1 = val.split('.')[0]
        v1 = parseFloat(v1)
        val = v1 + '.' + val.split('.')[1]
      } else {
        val = val !== '' ? parseFloat(val) : ''
      }
      return val
    }
  } else {
    return ''
  }
}

export function lastCity(arr) { // 取数组最后一个不为空的值
  if (!arr || arr.length === 0) {
    return ''
  } else {
    let len = arr.length
    let val = ''
    for (let i = len; i > -1; i--) {
      if (arr[i]) {
        val = arr[i]
        break
      }
    }
    return val
  }
}

export function getUuid() { // 生成唯一id
  let S4 = () => {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  let guid = () => {
    return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
  }
  return 'iy' + guid()
}

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : (('00' + str).substr(('' + str).length)))
    }
  }
  return fmt
}

export function getTimer(date, name = '发布') {
  let nName = name ? name + '于：' : ''
  let minute = 1000 * 60
  let hour = minute * 60
  let day = hour * 24
  let week = day * 7
  let month = day * 30
  let nt = new Date().getTime()
  let sd = new Date(date).getTime()
  let ct = nt - sd
  let result = ''
  if (ct < 0) {
    result = ''
  } else if (ct / month >= 1) {
    result = nName + Math.floor(ct / month) + '月前'
  } else if (ct / week >= 1) {
    result = nName + Math.floor(ct / week) + '周前'
  } else if (ct / day >= 1) {
    result = nName + Math.floor(ct / day) + '天前'
  } else if (ct / hour >= 1) {
    result = nName + Math.floor(ct / hour) + '小时前'
  } else if (ct / minute >= 1) {
    result = nName + Math.floor(ct / minute) + '分钟前'
  } else {
    result = '刚刚' + name
  }
  return result
}

// 图片压缩
export function compress(file, obj, callback) {
  try {
    const image = new Image()
    image.src = URL.createObjectURL(file)
    image.onload = function () {
      let w = image.width
      let h = image.height
      const scale = w / h
      w = obj.width || w
      h = obj.height || (w / scale)
      let quality = 0.7 // 默认图片质量
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const anw = document.createAttribute('width')
      anw.nodeValue = w
      const anh = document.createAttribute('height')
      anh.nodeValue = h
      canvas.setAttributeNode(anw)
      canvas.setAttributeNode(anh)
      ctx.drawImage(image, 0, 0, w, h)
      if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
        quality = obj.quality
      }
      const data = canvas.toDataURL('image/jpeg', quality)
      callback(convertBase64UrlToBlob(data))
    }
  } catch (e) {
    console.log('压缩失败')
  }
}

export function convertBase64UrlToBlob(urlData) {
  // base转图片类型
  const bytes = window.atob(urlData.split(',')[1])
  const ab = new ArrayBuffer(bytes.length)
  const ia = new Uint8Array(ab)
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  return new Blob([ab], {type: 'image/png'})
}

// 薪资
export function salaryString(min, max, type) {
  let u = ''
  if (type === '1') {
    u = '/年'
  } else if (type === '2') {
    u = '/月'
  } else if (type === '3') {
    u = '/周'
  } else if (type === '4') {
    u = '/时'
  } else if (type === '5') {
    u = '/天'
  }
  if (!min && !max) {
    return '面议'
  } else if (!max) {
    let n = Number(min)
    if (n > 10000) {
      n = Math.round(n / 100) / 100 + '万'
    } else if (n > 1000) {
      n = Math.round(n / 10) / 100 + '千'
    } else {
      n = n + '元'
    }
    return n + u + '以上'
  } else {
    let i = Number(min)
    let a = Number(max)
    if (a > 10000) {
      i = Math.round(i / 100) / 100
      a = Math.round(a / 100) / 100 + '万'
    } else if (a > 1000) {
      i = Math.round(i / 10) / 100
      a = Math.round(a / 10) / 100 + '千'
    } else {
      a = a + '元'
    }
    return i + ' - ' + a + u
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js